// imove-branch: 是否是不需要登录的页面

export default async function(ctx) {
  // 虽然app全部页面都检查登录状态，但是就算不登录成功这些页面也可以直接显示
  const { NO_NEED_LOGIN_PAGES = [], pathname = '' } = ctx.payload;
  const needAuthPath = NO_NEED_LOGIN_PAGES.indexOf(pathname) === -1;
  return !needAuthPath;
}